$(document).ready(function () {
  // 最新消息彙整頁, 標籤頁, 分類頁
  if ( $('.frame').data('page') == 'posts' || $('.frame').data('page') == 'posts-tag' || $('.frame').data('page') == 'posts-category' ) {
    const newsBannerAni = gsap.timeline();
    newsBannerAni
      .from("#news-meg", { duration: 0.3, scale: 0, ease: 'circ.out' })
      .from("#news-align", { duration: 0.3, scale: 0, ease: 'circ.out' })
      .from(".news-hand-img", { delay: 0.1, duration: 0.5, y: 180, x: 100, ease: 'circ.out' })
      .from("#news-file", { duration: 0.3, scale: 0, ease: 'circ.out' })
      .from(".showcase_bn_arrow", { delay: 0.5, duration: 0.5, opacity: 0, y: -20, stagger: 0.5, repeat: -1, repeatDelay: 3 })
  }

  // 子分類頁
  if ( $('.frame').data('page') == 'posts-subcategory' ) {
    const newsBannerAni = gsap.timeline();
    gsap.set(".hexagon", { transformOrigin: "center center" });
    newsBannerAni
      .from(".hexagon", {
        opacity: 0,
        duration: 1.5,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
        stagger: function(index) {
          return index % 3 === 0 ? 0 : 0.6;
        }
      });
  }
});
